import React from 'react';
import styled from 'styled-components';

import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Switch from '@mui/material/Switch';

import { useMapSettings } from 'ff/debrief/hooks';

const MapModeToggle = () => {
    const { mapMode, toggleMapMode } = useMapSettings();

    const handleClick = () => {
        toggleMapMode();
    };

    return (
        <Box
            sx={{
                ml: 1,
                px: 1,
                py: 0.5,
                height: '32px',
                borderRadius: '4px',
                display: 'inline-block',
                backgroundColor: '#FFFFFF',
            }}
        >
            <Stack direction="row" alignItems="center">
                <Label ml={1}>2D</Label>
                <Switch
                    onChange={handleClick}
                    checked={mapMode === '3D'}
                    size="small"
                ></Switch>
                <Label ml={0}>3D</Label>
            </Stack>
        </Box>
    );
};

const Label = styled(Typography)`
    font-size: 13px;
    color: #646468;
`;

export default MapModeToggle;
